import { render, staticRenderFns } from "./staff-role-edit.vue?vue&type=template&id=080eedbf&scoped=true&"
import script from "./staff-role-edit.vue?vue&type=script&lang=js&"
export * from "./staff-role-edit.vue?vue&type=script&lang=js&"
import style0 from "./staff-role-edit.vue?vue&type=style&index=0&id=080eedbf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080eedbf",
  null
  
)

export default component.exports